import queryString from 'query-string'
import { usingGet, EMPTY_SUCCESS_RESPONSE } from '@ocean/api'
import { FilterUtils } from '@ocean/utils'
import { RequirementsFilterItems } from 'modules/requirements/Requirements/types'

export const getProficiencies = (externalFilters: RequirementsFilterItems | {}) => {
  const filterValues = FilterUtils.getExternalFilterValues(externalFilters)
  if (FilterUtils.findEmptyFilter(filterValues)) return EMPTY_SUCCESS_RESPONSE
  const queryParams = queryString.stringify(filterValues, { skipNull: true })
  return usingGet(`search/requirements/overview?${queryParams}`, { useProxy: true })
}

export const getGroup = (groupId: Guid, externalFilters: RequirementsFilterItems) => {
  const filterValues = FilterUtils.getExternalFilterValues(externalFilters)
  if (FilterUtils.findEmptyFilter(filterValues)) return EMPTY_SUCCESS_RESPONSE
  const queryParams = queryString.stringify(filterValues, { skipNull: true })
  return usingGet(`search/requirements/group/${groupId}?${queryParams}`, { useProxy: true })
}
